/* eslint-disable no-plusplus */
import { v4 as uuid } from 'uuid';
import Firebase from '../firebase';
import { notify } from '../../functions/notifications';
import { CalcularDistancia, DataAtual } from '../../functions/helper';
import { constantes } from '../../constantes';

const urlApi = 'https://api.chat-api.com/instance257525/message?token=mu2rqpqltn0f3d52';

export function NotificarAplicacao(
  {
    celular, nome, data: dataAplicacao, horaInicial,
    horaFinal, tipo, produto, cidade, estado,
  },
) {
  const { $ } = window;
  const phone = `55${celular}`;
  const nomeEnviar = nome.split(' ')[0];
  const body = `Oi, ${nomeEnviar} está aí?

    Gostaria de notificar que identificamos uma aplicação ${tipo} de ${produto} próxima a sua localização em ${cidade} - ${estado}. A aplicação está prevista para o dia ${dataAplicacao}  com início ás ${horaInicial} e término às ${horaFinal}.

    Ah! Não se preocupe, visando a segurança da sua propriedade já informamos a sua localização ao aplicador e vamos te notificar no dia da aplicação também 😉

    Até mais 👋`;

  const data = {
    phone,
    body,
  };

  $.ajax(urlApi, {
    data: JSON.stringify(data),
    contentType: 'application/json',
    type: 'POST',
  });
}
export function NotificarCompraSegura({ celular, nome, link }) {
  const { $ } = window;
  const phone = `55${celular}`;
  const nomeEnviar = nome.split(' ')[0];
  const body = `Oi, ${nomeEnviar} está aí?

  Você acabou de realizar a compra segura de insumo hormonal em conformidade com a legislação vigente 😉.

  Segue abaixo o link de acesso a seu certificado de Venda Segura, podendo ser utilizado em fiscalizações.

  Ah! nesse certificado tem o QR CODE que te direciona para a plataforma AGSAFE onde você pode acompanhar os cultivos sensíveis próximos ao local da aplicação e alguma informaçãorelativas as boas práticas na aplicação.

  Até mais 👋

  ${link}
  `;

  const data = {
    phone,
    body,
  };

  $.ajax(urlApi, {
    data: JSON.stringify(data),
    contentType: 'application/json',
    type: 'POST',
  });
}

function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export function NotificarImg({ celular, file }) {
  const { $ } = window;
  const phone = `55${celular}`;
  const data = {
    phone,
    body: dataURLtoFile(file, 'teste.pdf'),
    filename: 'teste.pdf',
    caption: 'this image for @19982302626',
    cached: false,
  };

  $.ajax(urlApi, {
    data: JSON.stringify(data),
    contentType: 'application/json',
    type: 'POST',
  });
  console.log('teste', data);
}

export function NotificacaoFake(
  {
    celular, nome, data: dataAplicacao, horaInicial,
    horaFinal, tipo, produto, cidade, estado,
  },
) {
  const { $ } = window;
  const phone = `55${celular}`;
  const nomeEnviar = nome.split(' ')[0];
  const body = `Oi, ${nomeEnviar} está aí?

    Gostaria de notificar que identificamos uma aplicação ${tipo} de ${produto} próxima a sua localização em ${cidade} - ${estado}. A aplicação está prevista para o dia ${dataAplicacao}  com início ás ${horaInicial} e término às ${horaFinal}.

    Ah! Não se preocupe, visando a segurança da sua propriedade já informamos a sua localização ao aplicador e vamos te notificar no dia da aplicação também 😉

    Até mais 👋`;

  const data = {
    phone,
    body,
  };

  $.ajax(urlApi, {
    data: JSON.stringify(data),
    contentType: 'application/json',
    type: 'POST',
  });
}

export function NotificarAplicacaoProdutorAplicador({ celular, nome }) {
  const { $ } = window;
  const phone = `55${celular}`;
  const body = `Oi, ${nome.split(' ')[0]}.

  Seja muito bem vindo a AGSAFE, é um prazer ter você aqui. Verificamos que você é um Produtor Aplicador, por favor poderia nos informar *qual cultura* deseja que seja liberada em seu cadastro. Ficamos no aguardo, até mais 👋`;

  const data = {
    phone,
    body,
  };

  $.ajax(urlApi, {
    data: JSON.stringify(data),
    contentType: 'application/json',
    type: 'POST',
  });
}

export function EnviarNotificacao({ telefone, nome, codigo }) {
  const { $ } = window;
  const phone = `55${telefone}`;
  const nomeEnviar = nome;
  const token = 'mu2rqpqltn0f3d52';
  const url = `https://api.chat-api.com/instance257525/message?token=${token}`;
  const body = `Oi,  *${nomeEnviar}*! Que bom ter você aqui 😃

Olha que legal: agora, assim que uma aplicação de agroquímicos  for realizada próxima a sua localização você vai receber notificações em tempo real por aqui.

Ah! O código de confirmação da sua conta  *AGSAFE é ${codigo}.*`;

  const data = {
    phone,
    body,
  };

  $.ajax(url, {
    data: JSON.stringify(data),
    contentType: 'application/json',
    type: 'POST',
  });

  notify('success', 'Uma mensagem de confirmação foi enviada em seu whatsApp');
}
export function EnviarNotificacoes({ celular, nome, mensagem }) {
  const { $ } = window;
  const phone = `55${celular}`;
  const token = 'mu2rqpqltn0f3d52';
  const url = `https://api.chat-api.com/instance257525/message?token=${token}`;
  const body = `Olá ${nome}, ${mensagem}`;

  const data = {
    phone,
    body,
  };

  $.ajax(url, {
    data: JSON.stringify(data),
    contentType: 'application/json',
    type: 'POST',
  });
}
export function EnviarNotificacoesAvulsa({ numero, mensagem }) {
  const { $ } = window;
  const phone = `55${numero}`;
  const token = 'mu2rqpqltn0f3d52';
  const url = `https://api.chat-api.com/instance257525/message?token=${token}`;
  const body = mensagem;

  const data = {
    phone,
    body,
  };

  $.ajax(url, {
    data: JSON.stringify(data),
    contentType: 'application/json',
    type: 'POST',
  });
}

export function NotificacaoBoasVindas({ telefone, nome }) {
  const { $ } = window;
  const phone = `55${telefone}`;
  const nomeEnviar = nome.split(' ')[0];
  const token = 'mu2rqpqltn0f3d52';
  const url = `https://api.chat-api.com/instance257525/message?token=${token}`;
  const body = `Olá ${nomeEnviar}, sua conta foi ativada com sucesso. 😃 Seja bem vindo a *AGSAFE*.`;

  const data = {
    phone,
    body,
  };

  $.ajax(url, {
    data: JSON.stringify(data),
    contentType: 'application/json',
    type: 'POST',
  });

  notify('success', 'Conta ativada com sucesso, bem vindo a AGSAFE');
}

export const NotificarTodosOsUsuarios = ({
  data, horaInicial, horaFinal,
  tipo, produto, uidSender,
  latUser, lngUser,
}) => {
  const { raiosExibicao: { deriva } } = constantes;
  Firebase.firestore().collection('users').get().then((result) => {
    const cadastrosCultura = result.docs;
    cadastrosCultura.forEach((doc) => {
      const {
        celular, nome, uid, records,
      } = doc.data();
      const { marker, poligon: poligons } = records;

      const markers = marker.map((mark) => mark);

      const poligon = poligons.map((pol) => pol);
      const markerAndPoligon = [...markers, ...poligon];

      markerAndPoligon.forEach((item) => {
        const key = Object.keys(item)[0];
        const {
          active, positions, uidUsuario, cidade, estado,
        } = item[`${key}`];
        const { lat, lng } = positions[0];

        if (uidSender !== uidUsuario) {
          const raio = CalcularDistancia({
            lat1: latUser,
            lon1: lngUser,
            lat2: lat,
            lon2: lng,
          });

          if ((deriva > raio) && active) {
            const newUuid = uuid();
            const newUser = {
              ...doc.data(),
              notifications: [
                ...doc.data().notifications, {
                  [`${newUuid}`]: {
                    body: `Oi, ${doc.data().nome.split(' ')[0]} está aí?

                  Gostaria de notificar que identificamos uma aplicação ${tipo} de ${produto} próxima a sua localização em ${cidade} - ${estado}. A aplicação está prevista para o dia ${data}  com início ás ${horaInicial} e término às ${horaFinal}.

                  Ah! Não se preocupe, visando a segurança da sua propriedade já informamos a sua localização ao aplicador e vamos te notificar no dia da aplicação também 😉

                  Até mais 👋`,
                    data: DataAtual(),
                    read: false,
                    title: `${doc.data().nome.split(' ')[0]}, nova aplicação.`,
                    uid: newUuid,
                  },
                },
              ],
            };
            if (uidSender !== uid) {
              Firebase.firestore().collection('users').doc(uid).update(newUser)
                .then(() => {
                  NotificarAplicacao({
                    celular,
                    nome,
                    data,
                    horaInicial,
                    horaFinal,
                    tipo,
                    produto,
                    cidade,
                    estado,
                  });
                })
                .catch(() => {
                  notify('error', 'Erro ao atualizar o usuário');
                });
            }
          }
        }
      });
    });
  })
    .catch((erro) => {
      console.log(`Erro: ${erro.message}`);
    });
};
